import React from "react"
import CuratedHotelPage from "../../templates/hotels/CuratedHotelPage"

const Page = () => <CuratedHotelPage hotelKey="rosewoodCastiglionDelBosco" locale="fr" />

export default Page
